var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcXGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5312 3.52925C3.79155 3.2689 4.21366 3.2689 4.47401 3.52925L8.00261 7.05784L11.5312 3.52925C11.7915 3.2689 12.2137 3.2689 12.474 3.52925C12.7344 3.7896 12.7344 4.21171 12.474 4.47206L8.94541 8.00065L12.474 11.5292C12.7344 11.7896 12.7344 12.2117 12.474 12.4721C12.2137 12.7324 11.7915 12.7324 11.5312 12.4721L8.00261 8.94346L4.47401 12.4721C4.21366 12.7324 3.79155 12.7324 3.5312 12.4721C3.27085 12.2117 3.27085 11.7896 3.5312 11.5292L7.0598 8.00065L3.5312 4.47206C3.27085 4.21171 3.27085 3.7896 3.5312 3.52925Z",
    fill: "#4A5467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcXGrey);
export default __webpack_public_path__ + "static/media/ic-x-grey.a4636ec0989ffa531069a038b604d86a.svg";
export { ForwardRef as ReactComponent };